import React from "react"
import { useSelector } from "react-redux"
import { get, ref } from "firebase/database"
import FaceIcon from "@mui/icons-material/Face"

import { Link } from "react-router-dom"
import { Chip } from "@mui/material"
import { Instructor } from "../../../types"
import { RootState } from "../../../store/configureStore"
import { sdk9db } from "../../../firebase"

const PreviousInstructorSelect = () => {
  const { auth } = useSelector((state: RootState) => state.firebase)
  const [previousInstructors, setPreviousInstructors] = React.useState<
    Instructor[] | null
  >(null)

  React.useEffect(() => {
    if (!auth?.uid) return
    get(ref(sdk9db, `studentLessonSlotsV2/${auth.uid}`)).then((slotsSnap) => {
      const instructorsCollect: Instructor[] = []
      slotsSnap.forEach((slotSnap) => {
        const slot = slotSnap.val()
        if (slot) {
          instructorsCollect.push(slot.instructor)
        }
      })
      const uniqueInstructors = instructorsCollect.filter(
        (instructor, index, self) =>
          index === self.findIndex((t) => t.id === instructor.id),
      )
      setPreviousInstructors(uniqueInstructors)
    })
  }, [auth.uid])

  if (!previousInstructors?.length) {
    return null
  }

  return (
    <>
      <h3 style={{ lineHeight: "34px", fontWeight: 600 }}>
        Optionally show only your previous instructor:
      </h3>
      {previousInstructors.map((instructor) => (
        <React.Fragment key={instructor.id}>
          <Link to={`/instructor/${instructor.id}`}>
            <Chip
              icon={<FaceIcon />}
              label={instructor?.displayName}
              sx={{ mr: 1 }}
              data-cy="previous-instructor-chip"
            />
          </Link>
        </React.Fragment>
      ))}
    </>
  )
}

export default PreviousInstructorSelect
